var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningCircleGreen = function SvgWarningCircleGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 3.167a13.333 13.333 0 1 0 0 26.666 13.333 13.333 0 0 0 0-26.666Z",
    fill: "#D0DE33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.666 9.833a1.334 1.334 0 0 1 2.667 0v8a1.333 1.333 0 1 1-2.666 0v-8ZM16 25.833a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
    fill: "#0D1F23"
  })));
};
export default SvgWarningCircleGreen;